module.exports = require("@graphistry/falcor-path-utils/lib/toFlatBuffer");


//////////////////
// WEBPACK FOOTER
// external "@graphistry/falcor-path-utils/lib/toFlatBuffer"
// module id = 104
// module chunks = 0